import { useEffect, useState } from 'react';

export const useCalculateTableHeight = (
  containerHeight: number,
  divRef: React.RefObject<HTMLDivElement>,
  isShowError?: boolean
) => {
  const [tableBodyHeight, setTableBodyHeight] = useState(0);
  const TABLE_GAP = 8;

  useEffect(() => {
    const updateHeight = () => {
      if (divRef.current) {
        const layoutTop = divRef.current.querySelector(
          '[class*="transaction-item-layout"]'
        )?.clientHeight;
        const thead = divRef.current.getElementsByTagName('thead')[0];
        const tableHeaderHeight = divRef.current.querySelector(
          '[class*="header-container"]'
        )?.clientHeight;
        const tableFooterHeight = divRef.current.querySelector(
          '[class*="page-container"]'
        )?.clientHeight;

        const tableGap = TABLE_GAP * (tableFooterHeight ? 2 : 1);

        const errorHeight = isShowError
          ? divRef.current.querySelector('[class*="inline-error"]')
              ?.clientHeight ?? 0
          : 0;

        const computedStyle = window.getComputedStyle(divRef.current);
        const tableBodyHeight =
          containerHeight -
          parseFloat(computedStyle.paddingBottom) -
          parseFloat(computedStyle.paddingTop) -
          (thead?.clientHeight ?? 0) -
          (tableHeaderHeight ?? 32) -
          (tableFooterHeight ?? 24) -
          (layoutTop ? layoutTop + 1 : 0) -
          tableGap -
          errorHeight;
        setTableBodyHeight(tableBodyHeight);
      }
    };

    updateHeight();

    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, [containerHeight, divRef, setTableBodyHeight, isShowError]);

  return tableBodyHeight;
};
